import createCachedSelector from 're-reselect';
import { IQuality } from 'types/qualities';
import { IAppState } from 'types/app';

export const compareIds = (a: IQuality, b: IQuality) => Math.sign(a.id - b.id);
export const filterQualities = ({ name }: { name: string }) => (q: IQuality) => q.level > 0 && q.category === name;

const getName = (_state: IAppState, { name }: { name: string }) => name;
const getQualities = ({ myself: { qualities } }: IAppState) => qualities;

const cacheKey = getName;

const inputFuncs = [getName, getQualities];

const outputFunc = (name: string, qualities: IQuality[]) => [...qualities]
  .filter(filterQualities({ name }))
  .sort(compareIds);

// @ts-ignore
export default createCachedSelector(inputFuncs, outputFunc)(cacheKey);

